import React from 'react'
import styled from 'styled-components';
import SliderComp from './Slider';

const Projects = () => {
    return (
        <Container id='certification'>
            <h1><span className="green">Certifications</span></h1>
            <p>I proudly showcase my professional achievements and the specialized knowledge 
                I have gained through various certification programs. 
                These certifications validate my expertise and dedication in specific areas of study 
                or technologies, demonstrating my commitment to professional growth and 
                staying up-to-date with the latest industry trends and practices.</p>
            <SliderComp />
        </Container>
    )
}

export default Projects;

const Container = styled.div`
    max-width: 1280px;
    width: 80%;
    margin: 0 auto;
    padding: 3rem 0;
    text-align: center;
    position: relative;
    @media(max-width: 60%){
        width: 90%;
    }
    h1{
        font-size: 1.9rem;
    }

    p{
        width: 70%;
        margin: 0 auto;
        padding: 1rem 0;
        font-size: 0.9rem;
        @media(max-width : 500px){
            width: 90%;
        }
    }
`